import { useState, useEffect } from "react";
import { Input, Button, Space, Modal, Flex } from "antd";
import { SearchOutlined, UserOutlined } from "@ant-design/icons";
import { MyTable } from "../../ui/MyTable.jsx";
import { services } from "../../../services/index.js";
import { useSearchParams } from "react-router-dom";
import { sortBy } from "lodash";

const ClientSelectionDrawer = ({
  open,
  onCloseModal,
  selectedClientId,
  setSelectedClientId,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchValue, setSearchValue] = useState(null);
  const [pagination, setPagination] = useState({
    pageNo: 1,
    pageSize: 10,
    totalRecords: 0,
  });
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDraftId, setSelectedDraftId] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const draftID = searchParams.get("draftId");

  useEffect(() => {
    if (open)
      getClientsOptions(searchValue, pagination?.pageNo, pagination?.pageSize);
  }, [open, pagination?.pageNo, pagination?.pageSize, searchValue]);

  const getClientsOptions = async (
    searchValue = "",
    pageNo = 1,
    pageSize = 10,
  ) => {
    setLoading(true);
    const response = await services?.clientsService?.getClientsOptions({
      searchValue,
      pageNo,
      pageSize,
    });
    if (response) setClients(response?.data || []);
    else setClients([]);
    setLoading(false);
    setPagination({
      totalRecords: response?.totalRecords || 0,
      pageNo,
      pageSize,
    });
  };

  const handleRowClick = (record) => {
    setSelectedClientId(record?.id);
    setSelectedDraftId(record?.draft?.id);
    setSelectedRowKeys([record?.id]);
  };

  // const handleConfirm = () => {
  //   if (selectedClientId) {
  //     if (selectedDraftId) {
  //       setSearchParams({
  //         clientId: selectedClientId,
  //         draftId: selectedDraftId,
  //       });
  //     } else setSearchParams({ clientId: selectedClientId });
  //     onClose();
  //   }
  // };

  const handleConfirm = () => {
    if (selectedClientId) {
      setSearchParams({
        clientId: selectedClientId, // ✅ MUST
        fromDrawer: "true", // ✅ IMPORTANT FLAG
        ...(selectedDraftId && { draftId: selectedDraftId }),
      });

      onClose();
    }
  };

  // setSearchParams({
  //   clientId: selectedClientId,
  //   ...(selectedDraftId && { draftId: selectedDraftId }),
  // });

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sortBy: (a, b) => sortBy([a.name, b.name]),
    },
    {
      title: "Phone Number",
      key: "phone",
      render: (_, record) => (
        <span>
          {record.countryCode || "+92"} {record.telephone}
        </span>
      ),
    },
  ];
  const rowSelection = {
    type: "radio",
    selectedRowKeys,
    onChange: (_, selectedRows) => {
      if (selectedRows.length) handleRowClick(selectedRows[0]);
    },
  };
  const onClose = () => {
    setSearchValue(null);
    setSelectedClientId(null);
    setSelectedRowKeys([]);
    onCloseModal();
  };

  return (
    <Modal
      title={
        <Space>
          <UserOutlined />
          Select Client
        </Space>
      }
      open={open}
      onCancel={onClose}
      footer={[
        <Button onClick={onClose}>Cancel</Button>,
        <Button
          type="primary"
          onClick={handleConfirm}
          disabled={!selectedClientId}
        >
          Confirm Selection
        </Button>,
      ]}
      width={600}
    >
      <Flex vertical gap="small" className="mt-3">
        <Input
          placeholder="Search by name or phone number..."
          prefix={<SearchOutlined />}
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value);
            setPagination((prev) => ({ ...prev, pageNo: 1 }));
          }}
          allowClear
        />
        <MyTable
          columns={columns}
          data={clients}
          rowKey="id"
          loading={loading}
          paginationSize="small"
          pagination={{
            pageNo: pagination?.pageNo,
            pageSize: pagination?.pageSize,
            totalRecords: pagination?.totalRecords,
          }}
          rowSelection={rowSelection}
          onRow={(record) => ({
            onClick: () => handleRowClick(record),
            style: { cursor: "pointer" },
          })}
          onChange={(pageNo, pageSize) => {
            getClientsOptions(searchValue, pageNo, pageSize);
          }}
        />
      </Flex>
    </Modal>
  );
};

export { ClientSelectionDrawer };
